export enum job_mode {
    Presential = 'Presencial',
    Remote = 'Remoto',
    DefaulStatus = Presential
}
